import * as Mod1 from "./discourse/components/modal/local-dates-create";
import * as Mod2 from "./discourse/initializers/local-dates-admin-plugin-configuration-nav";
import * as Mod3 from "./initializers/discourse-local-dates";
import * as Mod4 from "./lib/date-with-zone-helper";
import * as Mod5 from "./lib/discourse-markdown/discourse-local-dates";
import * as Mod6 from "./lib/format-local-date";
import * as Mod7 from "./lib/generate-current-date-markup";
import * as Mod8 from "./lib/local-date-builder";
import * as Mod9 from "./lib/local-date-markup-generator";
import * as Mod10 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/components/modal/local-dates-create": Mod1,
  "discourse/initializers/local-dates-admin-plugin-configuration-nav": Mod2,
  "initializers/discourse-local-dates": Mod3,
  "lib/date-with-zone-helper": Mod4,
  "lib/discourse-markdown/discourse-local-dates": Mod5,
  "lib/format-local-date": Mod6,
  "lib/generate-current-date-markup": Mod7,
  "lib/local-date-builder": Mod8,
  "lib/local-date-markup-generator": Mod9,
  "lib/rich-editor-extension": Mod10,
};
export default compatModules;
